<template>
  <div>
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center mr-10">
        <v-img
          class="mx-2"
          src="../../assets/IDV.png"
          max-height="100"
          max-width="100"
        ></v-img>
      </div>
      <v-toolbar-items class="hidden-xs-only">
        <v-menu open-on-hover offset-y>
          <template v-slot:activator="{ attrs, on }">
            <v-btn
              depressed
              :style="{ 'background-color': 'transparent' }"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left> mdi-database </v-icon>
              Données de Base
            </v-btn>
          </template>

          <v-list>
            <v-list-item
              v-for="item in donnesBase"
              :key="item.title"
              :to="item.link"
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="item.title"> </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

        <v-btn
          v-for="item in menuItems"
          :key="item.title"
          :to="item.link"
          depressed
          :style="{ 'background-color': 'transparent' }"
        >
          <v-icon left>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>

      <v-spacer></v-spacer>
      <v-btn href="" target="_blank" text>
        <span class="mr-2">Mon Compte</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sideNav: false,
      donnesBase: [
        {
          icon: "mdi-google-maps",
          title: "Site",
          link: "/Site",
        },
        {
          icon: "mdi-bus",
          title: "Véhicule",
          link: "/Véhicule",
        },
        {
          icon: "mdi-account",
          title: "Employé",
          link: "/Employe",
        },
        {
          icon: "mdi-solid",
          title: "Parcelle",
          link: "/Parcelle",
        },
        {
          icon: "mdi-sprout",
          title: "Variété",
          link: "/Variété",
        },
      ],
      menuItems: [
        {
          icon: "mdi-playlist-check",
          title: "Présence",
          link: "/PointagePresence",
        },
        {
          icon: "mdi-playlist-check",
          title: "Pointage Analytique",
          link: "/PointageAnalitique",
        },
        {
          icon: "mdi-playlist-check",
          title: "Transport MO",
          link: "/PointageTrans",
        },
      ],
    };
  },
};
</script>
